import React from 'react';
import { MapPin, Plus, Edit2, Trash2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';

export const LocationsTab = ({ locations, onAdd, onEdit, onDelete, canEdit = true }) => (
  <Card data-testid="locations-card">
    <CardHeader className="flex flex-row items-center justify-between">
      <CardTitle className="text-lg flex items-center gap-2">
        <MapPin className="h-5 w-5 text-amber-500" />
        Delivery Locations
      </CardTitle>
      {canEdit && (
        <Button variant="outline" size="sm" onClick={onAdd} data-testid="add-location-btn">
          <Plus className="h-4 w-4 mr-2" />
          Add Location
        </Button>
      )}
    </CardHeader>
    <CardContent>
      {locations.length === 0 ? (
        <div className="text-center py-8">
          <MapPin className="h-12 w-12 text-gray-300 mx-auto mb-4" />
          <p className="text-gray-500">No delivery locations configured</p>
          {canEdit && (
            <Button variant="outline" className="mt-4" onClick={onAdd}>
              <Plus className="h-4 w-4 mr-2" />
              Add Your First Location
            </Button>
          )}
        </div>
      ) : (
        <div className="space-y-4">
          {locations.map((location) => (
            <div
              key={location.id}
              className="p-4 border rounded-lg hover:bg-gray-50"
              data-testid={`location-${location.id}`}
            >
              <div className="flex justify-between items-start">
                <div>
                  <div className="flex items-center gap-2">
                    <h3 className="font-semibold text-gray-900">{location.name}</h3>
                    {location.is_default && (
                      <span className="text-xs bg-amber-100 text-amber-800 px-2 py-0.5 rounded">Default</span>
                    )}
                  </div>
                  <p className="text-gray-600 mt-1">{location.address}</p>
                  <p className="text-gray-600">
                    {location.city}, {location.state} {location.zip_code}
                  </p>
                  {location.delivery_instructions && (
                    <div className="mt-2">
                      <p className="text-xs text-gray-500 uppercase">Delivery Instructions</p>
                      <p className="text-sm text-gray-700">{location.delivery_instructions}</p>
                    </div>
                  )}
                  {location.receiving_hours && (
                    <div className="mt-2">
                      <p className="text-xs text-gray-500 uppercase">Receiving Hours</p>
                      <p className="text-sm text-gray-700">{location.receiving_hours}</p>
                    </div>
                  )}
                </div>
                <div className="flex gap-2">
                  {canEdit ? (
                    <>
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => onEdit(location)}
                      >
                        <Edit2 className="h-4 w-4" />
                      </Button>
                      <Button
                        variant="ghost"
                        size="icon"
                        className="text-red-500 hover:text-red-600"
                        onClick={() => onDelete(location.id)}
                      >
                        <Trash2 className="h-4 w-4" />
                      </Button>
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </CardContent>
  </Card>
);
